import { defineStore } from "pinia";
import { USER_TYPE, USER_POSITION, MANGE_MEMBERS_MODE } from '/constants/common.js'

export const useUserStore = defineStore("user", () => {
  const type = ref(USER_TYPE.GUEST);
  const position = ref(USER_POSITION.STAFF);
  const loginErrorMessage = ref("");
  const favoriteList = ref([]);
  const favoriteListCount = ref(0);
  const downloadList = ref([]);
  const downloadListCount = ref(0);
  const manageMembersMode = ref(MANGE_MEMBERS_MODE.VIEW)
  const adminEditInfo = ref({})
  const userEditInfo = ref({})
  const userOnlyCountries = ref([])
  const emailTemplate = ref({})
  const emailTypeOptions = ref([])
  const signStatusOptions = ref([])
  
  const setUserTypePosition = (userData) => {
    type.value = userData.userType
    position.value = userData.userRole
  }
  
  const getFavoriteList = async ({ userId, locale, page, limit }) => {
    if (favoriteList.value.length > 0) {
      return;
    }
    favoriteList.value = [];
    favoriteListCount.value = 0;
    const {
      data: {
        data: { data, totalCount },
      },
    } = await usePost(`/favorite/q/u`, {
      userId,
      locale,
      page,
      limit,
    })
    favoriteList.value = data
    favoriteListCount.value = totalCount
  }

  const resetFavoriteList = async ({ userId, locale, page, limit }) => {
    const {
      data: {
        data: { data, totalCount },
      },
    } = await usePost(`/favorite/q/u`, {
      userId,
      locale,
      page,
      limit,
    });
    favoriteList.value = data;
    favoriteListCount.value = totalCount;
  };
  
  const getDownloadList = async ({ userId, locale, page, limit }) => {
    if (downloadList.value.length > 0) {
      return;
    }
    const {
      data: {
        data: { data, totalCount },
      },
    } = await usePost(`/download/q/u`, {
      userId,
      locale,
      page,
      limit,
    });
    downloadList.value = data;
    downloadListCount.value = totalCount;
  };

  const resetDownloadList = async ({ userId, locale, page, limit }) => {
    const {
      data: {
        data: { data, totalCount },
      },
    } = await usePost(`/download/q/u`, {
      userId,
      locale,
      page,
      limit,
    });
    downloadList.value = data;
    downloadListCount.value = totalCount;
  };

  const doFavorite = async ({ userId, yarnlogId }) => {
    return apiWrapper(async () => {
      const { data } = usePost(`/favorite/i`, {
        userId,
        yarnlogId,
      })
      return data
    })
  }

  const undoFavorite = async ({ userId, id }) => {
    return apiWrapper(async () => {
      const { data } = usePost(`/favorite/d`, {
        userId,
        id,
      });
      return data;
    })
  }

  const setManageMembersMode = (target) => {
    manageMembersMode.value = target
  }
  
  const clickChangeConnectionLog = (connectionNumber) => {
    const authStore = useAuthStore()
    return apiWrapper(async () => {
      const {
        data: { status }
      } = await usePost('/connection/i',
        {
          connectionNumber,
          userId: authStore.user.userId
        }
      )
      return status
    })
  };

  const clickExternalLog = (yarnlogId) => {
    const authStore = useAuthStore()
    return apiWrapper(async () => {
      const {
        data: { status }
      } = await usePost('/externallink/i',
        {
          yarnlogId,
          userId: authStore.user.userId
        }
      )
      return status
    })
  }
  
  const getUserInfoById = async ( {userId, locale} ) => {
    const {
      data: { data }
    } = await usePost(`/user/q`, {
      userId,
      locale
    })
    return data
  }

  const getUserOnlyCountries = (optionalOption) => {
    return [optionalOption, ...userOnlyCountries.value].filter(n => n)
  }

  const fetchUserOnlyCountries = async (locale) => {
    if (userOnlyCountries.value.length) return

    const baseStore = useBaseStore()
    baseStore.setSpinner()

    return apiWrapper(async () => {
      const response = await callPostWithToken(
        '/user/q/country',
        { locale }
      )

      const { data } = response.data

      userOnlyCountries.value = data.map(({ countryCode, countryName, ...rest }) => ({
        value: countryCode,
        text: countryName,
        ...rest
      }))

      baseStore.hideSpinner()
      return data
    })
  }
  
  const giveManagerAuthority = async (params) => {
    const result = await usePost("/user/group/c/m", {
      ...params,
    });
    return result.data.status;
  };

  return {
    type,
    position,
    loginErrorMessage,
    favoriteList,
    manageMembersMode,
    downloadList,
    favoriteList,
    favoriteListCount,
    downloadListCount,
    adminEditInfo,
    clickChangeConnectionLog,
    setUserTypePosition,
    getFavoriteList,
    resetFavoriteList,
    doFavorite,
    undoFavorite,
    getDownloadList,
    resetDownloadList,
    setManageMembersMode,
    clickExternalLog,
    getUserInfoById,
    userEditInfo,
    getUserOnlyCountries,
    userOnlyCountries,
    fetchUserOnlyCountries,
    emailTemplate,
    emailTypeOptions,
    signStatusOptions,
    giveManagerAuthority
  };
});
